type MessageType = string | (() => string);

class InvariantError extends TypeError {
  name = "InvariantError";
  constructor(value: unknown, message?: string) {
    super(message ?? `Assertion failed - value is ${String(value)}`);
  }
}

export function invariant(
  value: unknown,
  message?: MessageType,
): asserts value {
  if (value) {
    return;
  }

  const msg = typeof message === "function" ? message() : message;

  throw new InvariantError(value, msg);
}

// allows to define a Tuple of N length
// copied from https://stackoverflow.com/a/52490977/1850276
type Tuple<T, N extends number> = N extends N
  ? number extends N
    ? readonly T[]
    : _TupleOf<T, N, readonly []>
  : never;
type _TupleOf<
  T,
  N extends number,
  R extends readonly unknown[],
> = R["length"] extends N ? R : _TupleOf<T, N, readonly [T, ...R]>;

export function isArrayOfLength<T, Length extends number>(
  array: readonly T[],
  length: Length,
): array is Tuple<T, Length> {
  return array.length === length;
}

// export function assertArrayOfLength<T, Length extends number>(
//   array: readonly T[],
//   length: Length,
//   message: MessageType = `Expected array to be of length ${length}, but was ${array.length}`,
// ): asserts array is Tuple<T, Length> {
//   invariant(isArrayOfLength(array, length), message);
// }

export function isArrayOfAtLeastOne<T>(
  array: readonly T[],
): array is readonly [T, ...T[]] {
  return array.length > 0;
}

export function assertArrayOfAtLeastOne<T>(
  array: readonly T[],
  message: MessageType = "Expected array to have at least one entry, but it did not",
): asserts array is readonly [T, ...T[]] {
  invariant(isArrayOfAtLeastOne(array), message);
}
